import { Icon16Clear } from "@vkontakte/icons";
import {
  AdaptivityProvider,
  Checkbox,
  CustomSelectOption,
  Flex,
  FormItem,
  Group,
  IconButton,
  Input,
  Select,
} from "@vkontakte/vkui";
import { UIButton } from "../../UIButton/UIButton";
import s from "./style.module.scss";

import { paramsAtom, updateParamsAction } from "@/core/reatom/state/search/";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAction, useAtom } from "@reatom/npm-react";
import { Controller, Resolver, useForm } from "react-hook-form";
import { CloseButton } from "../../CloseButton/CloseButton";
import { options } from "./lib/options";
import { schema } from "./lib/schema";
import { FilterFormData } from "./lib/types";

interface FilterProps {
  closeModal: () => void;
}

export const FilterForm = (props: FilterProps) => {
  const [params] = useAtom(paramsAtom);
  /* const [cities] = useAtom(citiesAtom);
  const [country] = useAtom(countriesAtom);
  const handleCity = useAction(getCityAction); */
  const { closeModal } = props;
  /* const countryOption = useMemo(() => {
    return country.map((item) => ({
      label: item.name,
      value: item.id,
    }));
  }, [country]); */
  // const [searchCity, setSearchCity] = useState("");
  // const [selectedCountry, setSelectedCountry] = useState(0);
  const handleUpdateParams = useAction(updateParamsAction);
  /* const cityOption = useMemo(() => {
    return cities
      .filter((item) =>
        searchCity
          ? item.name.toLowerCase().includes(searchCity.toLowerCase())
          : true
      )
      .map((item) => ({
        label: item.name,
        value: item.id,
      }));
  }, [cities, searchCity]); */
  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm<FilterFormData>({
    resolver: yupResolver(schema) as Resolver<FilterFormData>,
    defaultValues: {
      sort_by: params.sort_by ? params.sort_by : null,
      price_from: params.price_from ? params.price_from : null,
      price_to: params.price_to ? params.price_to : null,
      days_from: params.days_from ? params.days_from : null,
      days_to: params.days_to ? params.days_to : null,
      freelancer_online: params.freelancer_online
        ? !!params.freelancer_online
        : false,
      complete_in_one_day: params.complete_in_one_day
        ? !!params.complete_in_one_day
        : false,
      only_no_view: params.only_no_view ? !!params.only_no_view : false,
      // city_ids: params.city_ids ? params.city_ids : null,
      // country_id: params.country_id ? params.country_id : null,
    },
  });

  const onSubmit = (data: FilterFormData) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    handleUpdateParams(data);
    closeModal();
  };

  return (
    <div className={s.wrapper}>
      <CloseButton onClose={closeModal} />
      <div className={s.header}>
        <UIButton
          fontType={"tertiary"}
          color="white"
          className={s.clearButton}
          onClick={() =>
            reset({
              sort_by: null,
              price_from: null,
              price_to: null,
              days_from: null,
              days_to: null,
              freelancer_online: false,
              complete_in_one_day: false,
              only_no_view: false,
            })
          }
        >
          Очистить
        </UIButton>
        <p className={s.title}>Фильтры</p>
        <div></div>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className={s.form}>
        <AdaptivityProvider sizeY={"regular"}>
          <Group>
            <FormItem top="Сортировка" htmlFor="select-id" noPadding>
              <Controller
                name="sort_by"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    id="select-id"
                    placeholder="Не выбран"
                    renderOption={({ option, ...restProps }) => (
                      <CustomSelectOption {...restProps} key={option.value} />
                    )}
                    options={options}
                  />
                )}
              />
            </FormItem>
            <FormItem
              top="Диапозон цены"
              htmlFor="select-id"
              noPadding
              className={s.formItem}
            >
              <Flex direction="row" justify="space-between">
                <div className={s.miniInput}>
                  <div className={s.errorWrapper}>
                    <Input
                      {...register("price_from", {
                        setValueAs: (value) => (value ? +value : null),
                      })}
                      id="exampleClickable"
                      type="number"
                      placeholder="от 1000₽"
                      after={
                        (!!watch("price_from") ||
                          watch("price_from") === 0) && (
                          <IconButton
                            hoverMode="opacity"
                            label="Очистить поле"
                            onClick={() => setValue("price_from", null)}
                          >
                            <Icon16Clear />
                          </IconButton>
                        )
                      }
                    />
                    {errors.price_from && (
                      <div className={s.error}>{errors.price_from.message}</div>
                    )}
                  </div>
                </div>
                <div className={s.miniInput}>
                  <div className={s.errorWrapper}>
                    <Input
                      {...register("price_to", {
                        setValueAs: (value) => (value ? +value : null),
                      })}
                      id="exampleClickable"
                      type="number"
                      placeholder="до 1299999₽"
                      after={
                        (!!watch("price_to") || watch("price_to") === 0) && (
                          <IconButton
                            hoverMode="opacity"
                            label="Очистить поле"
                            onClick={() => setValue("price_to", null)}
                          >
                            <Icon16Clear />
                          </IconButton>
                        )
                      }
                    />
                    {errors.price_to && (
                      <div className={s.error}>{errors.price_to.message}</div>
                    )}
                  </div>
                </div>
              </Flex>
            </FormItem>
            <FormItem
              top="Срок"
              htmlFor="select-id"
              noPadding
              className={s.formItem}
            >
              <Flex direction="row" justify="space-between">
                <div className={s.miniInput}>
                  <div className={s.errorWrapper}>
                    <Input
                      {...register("days_from", {
                        setValueAs: (value) => (value ? +value : null),
                      })}
                      id="exampleClickable"
                      type="text"
                      placeholder="от 1 дня"
                      after={
                        (!!watch("days_from") || watch("days_from") === 0) && (
                          <IconButton
                            hoverMode="opacity"
                            label="Очистить поле"
                            onClick={() => setValue("days_from", null)}
                          >
                            <Icon16Clear />
                          </IconButton>
                        )
                      }
                    />
                    {errors.days_from && (
                      <div className={s.error}>{errors.days_from.message}</div>
                    )}
                  </div>
                </div>
                <div className={s.miniInput}>
                  <div className={s.errorWrapper}>
                    <Input
                      {...register("days_to", {
                        setValueAs: (value) => (value ? +value : null),
                      })}
                      id="exampleClickable"
                      type="number"
                      placeholder="до 90 дней"
                      after={
                        (!!watch("days_to") || watch("days_to") === 0) && (
                          <IconButton
                            hoverMode="opacity"
                            label="Очистить поле"
                            onClick={() => setValue("days_to", null)}
                          >
                            <Icon16Clear />
                          </IconButton>
                        )
                      }
                    />
                    {errors.days_to && (
                      <div className={s.error}>{errors.days_to.message}</div>
                    )}
                  </div>
                </div>
              </Flex>
            </FormItem>
            {/* <FormItem
              top="Страна"
              htmlFor="select-id"
              noPadding
              className={s.formItem}
            >
              <Select
                searchable
                id="select-id"
                placeholder="Не выбран"
                renderOption={({ option, ...restProps }) => (
                  <CustomSelectOption {...restProps} key={option.value} />
                )}
                onChange={(_, selectValue) => {
                  if (selectValue) {
                    setSelectedCountry(+selectValue);
                    handleCity(+selectValue);
                    setValue("country_id", +selectValue);
                  } else {
                    setSelectedCountry(0);
                    setValue("country_id", null);
                  }
                }}
                options={countryOption}
                value={watch("country_id")?.toString()}
              />
            </FormItem>
            {selectedCountry != 0 && (
              <FormItem
                top="Город"
                htmlFor="select-id"
                noPadding
                className={s.formItem}
              >
                <Select
                  searchable
                  id="select-id"
                  placeholder="Не выбран"
                  renderOption={({ option, ...restProps }) => (
                    <CustomSelectOption {...restProps} key={option.value} />
                  )}
                  style={{ WebkitAppearance: "none" }}
                  options={cityOption.slice(0, 100)}
                  onInputChange={(e) => setSearchCity(e.target.value)}
                  onChange={(_, selectValue) => {
                    setValue("city_ids", selectValue ? +selectValue : null);
                  }}
                  value={watch("city_ids")?.toString()}
                />
              </FormItem>
            )} */}

            <FormItem noPadding className={s.formItem}>
              <Controller
                name="freelancer_online"
                control={control}
                render={({ field }) => (
                  <Checkbox
                    {...field}
                    className={s.checkbox}
                    checked={field.value}
                    value=""
                  >
                    Продавец онлайн
                  </Checkbox>
                )}
              />
              <Controller
                name="complete_in_one_day"
                control={control}
                render={({ field }) => (
                  <Checkbox
                    {...field}
                    className={s.checkbox}
                    checked={field.value}
                    value=""
                  >
                    Выполнит за 1 день
                  </Checkbox>
                )}
              />
              <Controller
                name="only_no_view"
                control={control}
                render={({ field }) => (
                  <Checkbox
                    {...field}
                    className={s.checkbox}
                    checked={field.value}
                    value=""
                  >
                    Только не просмотренные
                  </Checkbox>
                )}
              />
            </FormItem>
          </Group>
        </AdaptivityProvider>

        <UIButton fontType={"primary-2"} type="submit" className={s.submit}>
          Применить
        </UIButton>
      </form>
    </div>
  );
};
